import { createSlice } from "@reduxjs/toolkit";
import { createApiCase } from "../../helpers/create.api.case";
import { createApiThunk } from "../../helpers/create.api.thunk";
import apiService from "../../services/api.service";
import { CarPlate, EvCar, NonEvCar, SampleSupra, SampleVellfire, Supercar } from "../../assets/images";

export const getProductList = createApiThunk(
  "getProductList",
  apiService.getProductList,
);

export const getProductInfo = createApiThunk(
  "getProductInfo",
  apiService.getProductInfo,
);

export const saveProduct = createApiThunk(
  "saveProduct",
  apiService.saveProduct,
);

export const getTopSearch = createApiThunk(
  "getTopSearch",
  apiService.getTopSearch,
);

export const getCategoryList = createApiThunk(
  "getCategoryList",
  apiService.getCategoryList,
);

export const initialData = {
  productListLoading: false,
  productInfoLoading: false,
  topSearchLoading: false,

  productList: [
    {
      id: 1,
      label: "Year Brand Model Trim",
      deal: 1300,
      image: SampleVellfire,
      tag: ["EV", "1 Year Warranty", "As-ls"],
      mileage: 24799,
      year: 2020,
      type: "Auto",
      price: 109000,
      location: "Selangor",
    },
    {
      id: 2,
      label: "Year Brand Model Trim",
      deal: 1300,
      image: SampleSupra,
      tag: ["EV", "1 Year Warranty", "As-ls"],
      mileage: 24799,
      year: 2020,
      type: "Auto",
      price: 109000,
      location: "Selangor",
    },
  ],
  categoryList: [
    {
      id: 1,
      value: "",
      label: "All",
      image: "",
    },
    {
      id: 2,
      value: "supercar",
      label: "Supercar",
      image: Supercar,
    },
    {
      id: 3,
      value: "ev car",
      label: "EV Car",
      image: EvCar,
    },
    {
      id: 4,
      value: "used car",
      label: "Non-EV Car",
      image: NonEvCar,
    },
    {
      id: 5,
      value: "car plate",
      label: "Car Plate",
      image: CarPlate,
    },
  ],
  topSearch: [],

  productMedia: {},

  galleryTab: "",

  filterData: {},
  applyFilterData: {},

  savedProduct: [],
  showingMoreProduct: false,
};

const dataSlice = createSlice({
  name: "product",
  initialState: initialData,
  reducers: {
    setFilteredProducts: (state, action) => {
      state.filteredProducts = action.payload;
    },

    setSavedProduct: (state, action) => {
      state.savedProduct = action.payload;
    },

    setFilterData: (state, action) => {
      state.filterData = action.payload;
    },
    setApplyFilterData: (state, action) => {
      state.applyFilterData = action.payload;
    },

    setProductMedia: (state, action) => {
      state.productMedia = action.payload;
    },

    setGalleryTab: (state, action) => {
      state.galleryTab = action.payload;
    },

    setShowingMoreProduct: (state, action) => {
      state.showingMoreProduct = action.payload;
    },

    // setFilterModel: (state, action) => {
    //   state.filterModel = action.payload;
    // },
  },
  extraReducers: (builder) => {
    createApiCase(builder, getProductList, {
      loading: "productListLoading",
      fulfilled: (state, action) => {
        state.productList = action.payload.data;
      },
    });
    createApiCase(builder, getTopSearch, {
      loading: "topSearchLoading",
      fulfilled: (state, action) => {
        state.topSearch = action.payload.data;
      },
    });
    createApiCase(builder, getProductInfo, {
      loading: "productInfoLoading",
      fulfilled: (state, action) => {
        state.productInfo = action.payload.data;
      },
    });
    createApiCase(builder, saveProduct, {
      loading: "saveProductLoading",
    });
  },
});

export const {
  setFilteredProducts,
  setFilterData,
  setApplyFilterData,
  setGalleryTab,
  setProductMedia,
  setSavedProduct,
  setShowingMoreProduct,
} = dataSlice.actions;

export default dataSlice.reducer;
